export class UserCredentialsModel {
  email: string;
  password: string;
  readonly type: string = 'SA';
}
